import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ToolsService {
    constructor() {}

    public getPropNameCaseSensitive(object: any, propName: string): string | null {
        if (Object.keys(object).some((o) => o.toLowerCase() == propName.toLowerCase())) {
            const resName: string = Object.keys(object).filter((o) => o.toLowerCase() == propName.toLowerCase())[0];
            return resName;
        }
        return null;
    }

    public reorderObjectKeys(obj, orderArray) {
      // Check if obj or orderArray is null or empty; if so, return an empty array
      if (!obj || !orderArray) {
        return [];
      }
    
      // Create an array of objects for fields in orderArray first
      const orderedFields = orderArray
        .map(field => ({ headerName: field, field }))  // Set headerName and field to the same value
        .filter(f => obj.hasOwnProperty(f.field));
    
      // Get the remaining fields in the object that are not in orderArray
    const remainingFields = Object.keys(obj)
        .filter(key => !orderArray.includes(key))
        .map(field => ({ headerName: field, field }));  // Set headerName and field to the same value
    
      // Concatenate ordered fields with the remaining fields
      return [...orderedFields, ...remainingFields];
    }

    public reOrderArrayBasedOnPropName(objectsArray: any[], knownProps: any[]) {
        return objectsArray.map((obj) => {
            const reorderedObj = {};

            // Add known properties in the specified order
            knownProps.forEach((prop) => {
                if (obj.hasOwnProperty(prop)) {
                    reorderedObj[prop] = obj[prop];
                }
            });

            // Add the remaining properties in their original order
            return { ...reorderedObj, ...obj };
        });
    }
}
